<template lang="pug">
.table_wrapper
  table.table(id="data-table")
    tr.th
      td.td Month
      td.td Total Created
      td.td In Progress
      td.td Completed
      td.td Rescheduled
      td.td Went to Appointment
      td.td % Completion Rate
      td.td(v-for="dynamicKey in dynamicReport" :key="dynamicKey.label") {{dynamicKey.label}} 
    tr.tr(v-for="month, monthIndex in labels", :key="month")
      td.td {{month}}
      td.td {{totalReferrals[monthIndex]}}
      td.td {{inProgress[monthIndex]}}
      td.td {{completed[monthIndex]}}
      td.td {{rescheduled[monthIndex]}}
      td.td {{wentToAppointment[monthIndex]}}
      td.td.bold.green {{completionPercentage[monthIndex]}}%
      td.td(v-for="dynamicKey, indexKey in dynamicReport" :key="dynamicKey.label + indexKey") {{dynamicKey.data[monthIndex]}}
    tr.tr
      td.td Total
      td.td {{totalReferralsSum}}
      td.td {{totalInProgress}}
      td.td {{totalCompleted}}
      td.td {{totalRescheduled}}
      td.td {{totalWentToAppointment}}
      td.td {{totalCompletionPercentage}}%
      td.td(v-for="dynamicKey, indexKey in dynamicReport" :key="dynamicKey.label + indexKey") {{dynamicKey.total}}
</template>
<script>
import accumulator from "@/helpers/accumulator";
import moment from "moment";
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    reportData: {
      required: true,
      type: Array,
    },
  },
  computed: {
    totalReferrals() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map((monthData) => monthData.totalReferrals || 0);
    },
    totalReferralsSum() {
      return this.totalReferrals.reduce(accumulator, 0);
    },
    inProgress() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map((monthData) => monthData.totalNew || 0);
    },
    totalInProgress() {
      return this.inProgress.reduce(accumulator, 0);
    },
    completed() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map((monthData) => monthData.totalCompleted || 0);
    },
    totalCompleted() {
      return this.completed.reduce(accumulator, 0);
    },
    rescheduled() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map(
        (monthData) => monthData.totalRescheduled || 0
      );
    },
    totalRescheduled() {
      return this.rescheduled.reduce(accumulator, 0);
    },
    wentToAppointment() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map(
        (monthData) => monthData.totalWentToAppointment || 0
      );
    },
    totalWentToAppointment() {
      return this.wentToAppointment.reduce(accumulator, 0);
    },
    completionPercentage() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map(
        (monthData) => monthData.completionPercentage || 0
      );
    },
    totalCompletionPercentage() {
      const sum = this.completionPercentage.reduce(accumulator, 0);
      const count = this.labels.length;
      return count > 0 ? (sum / count).toFixed(2) : "0.00";
    },
    dynamicReport() {
      return [];
    },
    labels() {
      if (!this.reportData || this.reportData.length === 0) return [];
      return this.reportData.map((monthData, index, arr) =>
        moment(
          monthData.referredAtMonth ||
            monthData.distributedAtMonth ||
            monthData.scheduledAtMonth
        ).format(arr.length > 12 ? "MMMM YY" : "MMMM")
      );
    },
  },
});
</script>
<style lang="scss" scoped>
.table_wrapper {
  width: 100%;
  margin-bottom: 80px;
}
.hr {
  margin-right: 30px;
}
.btn-margin-left {
  margin-left: 28px;
}
.table {
  width: 100%;
  color: #000;

  .th {
    padding-bottom: 14px;
    padding-top: 14px;
    height: auto;
    border-bottom: 0px;
    .td {
      font-weight: 700;
      text-transform: none;
    }
    background-color: $primaryBgDarkGrey;
  }

  .tr {
    padding-bottom: 14px;
    padding-top: 14px;
    height: auto;
    .td {
      height: auto;
      display: flex;
    }
    &:hover {
      background-color: transparent;
    }
    &:last-child {
      border-bottom: 0px;
    }
  }

  .td {
    font-size: 14px;
    display: flex;
    flex: 1;
  }
}
</style>
